import { ModalSpinnerComponent } from "./../../main/pages/modal-spinner/modal-spinner.component";
import { TokenStorageService } from "./token-storage.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { timeout, tap, catchError } from "rxjs/operators";
import { EMPTY, TimeoutError } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "environments/environment";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { RecupaiementComponent } from "app/main/pages/recupaiement/recupaiement.component";
import { error } from "console";
import { PopupstatusComponent } from "app/main/pages/popupstatus/popupstatus.component";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  i: number = 0;
  modalRef : NgbModalRef;
  constructor(private http: HttpClient, private authSrv: TokenStorageService, private modalService: NgbModal) {}
  exPath = ['checkService','checkCashin']
  api(data: any) {
    if (!data.schema_webservice.includes("checkService") && !data.schema_webservice.includes("checkCashin") && !data.schema_webservice.includes("needsUpdate") &&  !data.schema_webservice.includes("checkTransactionExpress")) {
      this.i = this.i + 1;
      if (!this.modalService.hasOpenModals() || data.bypass) {
        this.modalRef = this.modalService.open(ModalSpinnerComponent, {
          centered: true,
          backdrop: "static",
          windowClass: "custommodal",
        });        
      }
    }
    const formData = new FormData();
    if (data.params) {
      const keys = Object.keys(data.params);
      keys.forEach((key) => {
        formData.append(key, data.params[key]);
      });
    }
    //formData.append('listeRibs','[260,262]');

    return this.http.post(environment.apiUrl + data.schema_webservice, formData).pipe(
      catchError((error, _) => {
        if (error instanceof TimeoutError) {
          this.modalRef.close();
        }
        console.error("API Error : ", error.status);
        console.error("API Error : ", JSON.stringify(error));

        return EMPTY;
      }),
      timeout(60000),
      tap((response: any) => {
        if (!data.schema_webservice.includes("checkService") && !data.schema_webservice.includes("checkCashin") && !data.schema_webservice.includes("needsUpdate") &&  !data.schema_webservice.includes("checkTransactionExpress")) {
          this.i = this.i - 1;
          if (this.i <= 0) {
            this.modalRef.close();
          }
        }
        if (response && response.token) {
          this.authSrv.saveToken(response.token);          
        }
        if (response && response.nextToken) {
          this.authSrv.savenextToken(response.nextToken);
        }
        if (response.statusAtteint){
          setTimeout(() => {
            this.openPop(response.statusAtteint);
          }, 2000);
        }
        setTimeout(() => {
          this.modalRef.close();
        }, 30000);
      })
    );
  }

  recuDePaiement(dataService, nomService) {
    const modalRef = this.modalService.open(RecupaiementComponent, {
      centered: true,
      //size: "lg",
      backdrop: "static",
    });
    modalRef.componentInstance.dataService = dataService;
    modalRef.componentInstance.nomService = nomService;
  }

  openPop(data:any){
    const modal = this.modalService.open(PopupstatusComponent, {
      centered: true,backdrop: "static",
    });
    modal.componentInstance.data = data;
  }

  LoginWithGoogle(credentials: string): Observable<any> {
    const header = new HttpHeaders().set("Content-type", "application/json");
    return this.http.post(environment.apiUrl + "", JSON.stringify(credentials), { headers: header });
  }
}
